import * as React from "react";
import { SVGProps } from "react";
function SvgFileTypePptIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 29H6v-9h2v7h16v-7h2v9ZM6 2h20v9h-2V4H8v7H6V2Z"
        fill="#F5A623"
      />
      <path
        d="M8.37 12.7h2.286c.834 0 1.455.189 1.863.567.408.378.612.888.612 1.53 0 .648-.204 1.161-.612 1.539-.408.378-1.03.567-1.863.567h-1V19H8.37v-6.3Zm2.286 3.123c.426 0 .729-.084.909-.252.186-.174.279-.432.279-.774s-.093-.597-.28-.765c-.18-.174-.482-.261-.908-.261h-1v2.052h1Zm3.47-3.123h2.287c.834 0 1.455.189 1.863.567.408.378.612.888.612 1.53 0 .648-.204 1.161-.612 1.539-.408.378-1.03.567-1.863.567h-1V19h-1.286v-6.3Zm2.287 3.123c.426 0 .729-.084.909-.252.186-.174.279-.432.279-.774s-.093-.597-.28-.765c-.18-.174-.482-.261-.908-.261h-1v2.052h1Zm4.703-2.052h-1.809V12.7h4.896v1.071h-1.809V19h-1.278v-5.229Z"
        fill="#F5A623"
      />
    </svg>
  );
}
export default SvgFileTypePptIcon;
